"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInAudience = void 0;
var SignInAudience;
(function (SignInAudience) {
    SignInAudience["AzureADMyOrg"] = "AzureADMyOrg";
    SignInAudience["AzureADMultipleOrgs"] = "AzureADMultipleOrgs";
    SignInAudience["AzureADandPersonalMicrosoftAccount"] = "AzureADandPersonalMicrosoftAccount";
    SignInAudience["PersonalMicrosoftAccount"] = "PersonalMicrosoftAccount";
})(SignInAudience || (exports.SignInAudience = SignInAudience = {}));
//# sourceMappingURL=signInAudience.js.map